module.exports = __webpack_public_path__ + "img/icon-faq.2d31cce3.svg";